import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useSelector } from 'react-redux';
//slices
import { cartSelector } from 'slices/cart';
import { userSelector } from 'slices/user';
//api
import { createOrder } from 'api/ecommerce';
//utils
import { getSubTotalOrder, getTotalOrder } from 'utils/orderFunctions';
//components
import Title from 'components/backoffice/texts/title';
import OrderForm from 'components/backoffice/forms/orderForm';

const OrderCreatePage = () => {
  const { t } = useTranslation(['backoffice']);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { isNewShippingAddress, isStorePickup, shippingCosts, isGiftOrder, giftData, appliedCoupon, iva } =
    useSelector(cartSelector);
  const { benefitedBookstore, pickUpLibrary, shipping_address, billing_address } = useSelector(userSelector);
  const { setTitle } = useOutletContext();

  useEffect(() => {
    setTitle(t('orderCreate'));
    return () => {
      setTitle('');
    };
  }, [setTitle]);

  const onSubmit = async (data) => {
    setLoading(true);
    const sendValues = {
      biblioteca: data.biblioteca?.id || '',
      user: data.usuario.id,
      comentario: data.comentario || '',
      descuento: parseInt(data.descuento) || 0,
      order_status: data.order_status,
      payment_status: data.payment_status,
      payment_method: parseInt(data.payment_method),
      reembolso: data.reembolso || false,
      is_new_shipping_address: isNewShippingAddress,
      store_pickup: isStorePickup,
      shipping_cost: shippingCosts,
      finish_process: true,
      is_gift: isGiftOrder,
      billing_address: billing_address || {},
      shipping_address: shipping_address || {},
      benefited_company: data.benefited_company.id,
      applied_coupon: appliedCoupon || null,
      iva_order: iva.toFixed(2),
      total_order: getTotalOrder(data.items, data.descuento, shippingCosts),
      subtotal_order: getSubTotalOrder(data.items, data.descuento),
      items: data.items.map((item) => {
        return {
          id: item.product.id,
          quantity: parseInt(item.quantity),
          total_price: parseFloat(item.total_price),
          state: parseInt(item.state),
          discount: parseInt(item.discount) || 0,
        };
      }),
    };
    if (isStorePickup) {
      sendValues.bookstore_to_pickup = pickUpLibrary.id;
    }
    if (isGiftOrder === true) {
      sendValues.gift_data = giftData;
    }
    try {
      const { status } = await createOrder(sendValues);
      if (status === 200 || status === 201) {
        toast.success(t('creadocorrectamente'));
        navigate('/intranet/orders', { replace: true });
      } else toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
    } catch (error) {
      console.error('Error en onCreate:', error);
    }
    setLoading(false);
  };

  return (
    <>
      <Title text={t('orderCreate')} />
      <OrderForm onSubmit={onSubmit} isEditing={false} loading={loading} />
    </>
  );
};

export default OrderCreatePage;